import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from 'widget/components';

const Plug = () => {
  const { t } = useTranslation();

  return (
    <Text fontSize={14} color="light">
      {t`Sorry, this message is not supported in this version.`}
    </Text>
  );
};

export default Plug;
